import { useRef, useState } from "react";
import { Download, FileUp, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";

const TEMPLATE = "name,district,address,pincode,phone,services\nSahu Kirana Store,Surajpur,\"Main Road, Bhaiyathan\",497231,9000000000,\"aeps, dmt, bbps\"\n";

const downloadTemplate = () => {
  const url = URL.createObjectURL(new Blob([TEMPLATE], { type: "text/csv" }));
  const a = document.createElement("a");
  a.href = url; a.download = "partner-shops-template.csv"; a.click();
  URL.revokeObjectURL(url);
};

export const ShopImport = ({ onDone }) => {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/shops/import", fd);
      setResult(data);
      onDone();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <button className="btn-ghost justify-center" disabled={busy} onClick={() => input.current?.click()} data-testid="shops-import-btn">
        {busy ? <Loader2 size={16} className="animate-spin" /> : <FileUp size={16} />} Import Excel / CSV
      </button>
      <button className="btn-ghost justify-center" onClick={downloadTemplate} data-testid="shops-template-btn"><Download size={16} /> Template</button>
      <input ref={input} type="file" accept=".csv,.xlsx" className="hidden" onChange={pick} data-testid="shops-import-input" />
      <Dialog open={!!result} onOpenChange={(o) => !o && setResult(null)}>
        <DialogContent className="max-h-[85vh] overflow-y-auto border-white/10 bg-card text-white">
          <DialogHeader><DialogTitle>Import finished</DialogTitle></DialogHeader>
          {result && (
            <div className="space-y-4" data-testid="shops-import-result">
              <div className="grid grid-cols-3 gap-3 text-center">
                <div className="rounded-xl bg-ink p-3"><p className="font-display text-2xl font-bold text-emerald-300" data-testid="import-added">{result.added}</p><p className="text-xs text-slate-400">Added</p></div>
                <div className="rounded-xl bg-ink p-3"><p className="font-display text-2xl font-bold text-amber-300" data-testid="import-skipped">{result.skipped_duplicates}</p><p className="text-xs text-slate-400">Already existed</p></div>
                <div className="rounded-xl bg-ink p-3"><p className="font-display text-2xl font-bold text-red-300" data-testid="import-errors">{result.error_count}</p><p className="text-xs text-slate-400">Rows with errors</p></div>
              </div>
              {result.errors?.length > 0 && (
                <ul className="max-h-60 space-y-1 overflow-y-auto rounded-xl border border-white/10 p-3 text-xs">
                  {result.errors.map((e) => <li key={e.row} className="text-slate-300"><span className="font-mono text-red-300">Row {e.row}:</span> {e.error}</li>)}
                </ul>
              )}
              <p className="text-xs text-slate-400">Columns: name, district, address, pincode, phone, services. Services can be: aeps, dmt, bbps, recharge, upi, insurance, travel, pan, loans (comma separated).</p>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
